import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { PayoutDetails } from "./PayoutDetails";

export function createAdminPayoutDetailsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/admin/payouts/$payoutId",
    component: PayoutDetails,
    staticData: { reducedMobileTopPadding: true },
    head: () => ({
      meta: [{ title: "Payout Details" }],
    }),
  });
}
